import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface SidebarSubMenuNextUniDriver extends BaseUniDriver {
  isExpanded(): Promise<boolean>;
  click(): Promise<any>;
  isDisabled(): Promise<boolean>;
  getTitleText(): Promise<string>;
  triggerMouseEnter(): Promise<void>;
  isQuickNavOpen(): Promise<boolean>;
}
